import { FormControl as NbFormControl } from 'native-base';

import { primitive } from 'styles/constants';

import { addWithConfig } from '../../utils';

import type { _FormControlComponentType } from './types';

export const FormControl: _FormControlComponentType = NbFormControl;
FormControl.ErrorMessage = NbFormControl.ErrorMessage;
FormControl.HelperText = NbFormControl.HelperText;
FormControl.Label = NbFormControl.Label;

const FormControlWithConfig = addWithConfig(FormControl);
FormControl.ErrorMessage = addWithConfig(FormControl.ErrorMessage).withConfig({
  _stack: { flexGrow: 1, flexDirection: 'column', alignItems: 'flex-start' },
  _text: { fontSize: 'sm', color: primitive.$bbqRed },
});
FormControl.HelperText = addWithConfig(FormControl.HelperText);
FormControl.Label = addWithConfig(FormControl.Label);

export default FormControlWithConfig;
